module.exports = __webpack_public_path__ + "img/carrusel_3.77c64c96.svg";